import React from 'react';
import { History } from 'history';
import { Input, InputNumber, InputMultiline, InputSwitch, InputPicklist, Layout } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './quizresult-model';  //editable..
import QuizresultList from './quizresult-list.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class QuizresultDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} 
                model={Model} onLoad={this.onLoad} disableCard>              
                
                <Layout history={this.props.history} content={[
                    {caption: 'Details', child: 
                    <>
                        <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                        <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                        {AppService.isAppFullVersion() &&
                        <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                        }
                        <Input name='title' label='Title' value={this.state.datarow.title} readOnly/>
                        <InputMultiline name='content' label='Content' value={this.state.datarow.content} readOnly/>
                        <InputNumber name='seq' label='Seq' value={this.state.datarow.seq} readOnly/>
                        <InputNumber name='valuemin' label='Value Min.' value={this.state.datarow.valuemin} readOnly/>
                        <InputNumber name='valuemax' label='Value Max.' value={this.state.datarow.valuemax} readOnly/>
                        <InputNumber name='scale' label='Scale' value={this.state.datarow.scale} readOnly/>
                        <InputNumber name='factor' label='Factor' value={this.state.datarow.factor} readOnly/>
                        <Input name='tag' label='Tag' value={this.state.datarow.tag} readOnly/>
                    </>
                    },

                    {caption: 'Sections', child: 
                    this.state.datarow.id > 0 && this.props.history &&
                        <QuizresultList history={this.props.history} root={this.props.root} caption='Quiz Result Section' parentId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                    },

                    ]}
                    
                />                   
            </BaseDelete>
        );
    }
}